import { Component, OnInit } from "@angular/core";
import { AppSettings } from '../configuration/appsettings.config'
 

@Component({
  selector: 'nav-bar',
  templateUrl: './topnavigation.component.html',
})
export class TopNavigation implements OnInit {

  logoURL: string = "";

 
  ngOnInit(): void {

    

    this.logoURL = AppSettings.getParticipabtLogoURL();
  }


}
